import { useCallback } from 'react'

import {
  TableColumnFiltersState,
  TableSortingState,
  TableState,
} from '@revolut-internal/ui-kit-table'

import { UrlStateStorageKeys } from 'modules/Monitoring/url-state-storage/consts'
import { useHashedSearchParams } from 'modules/Monitoring/url-state-storage/useHashedSearchParams'

const TABLE_STATE_INITIAL_DATA: Partial<TableState> = {
  sorting: [],
  columnFilters: [],
}

export const useTableState = (key: UrlStateStorageKeys, contextKey?: string) => {
  const { state: tableState, updateState } = useHashedSearchParams<Partial<TableState>>({
    hashParamKey: key,
    initialState: TABLE_STATE_INITIAL_DATA,
    contextKey,
  })

  const handleSortingChange = useCallback(
    (newSortingState: TableSortingState) => {
      updateState(previousState => ({
        ...previousState,
        sorting: newSortingState,
      }))
    },
    [updateState],
  )

  const handleFiltersChange = useCallback(
    (newFilterState: TableColumnFiltersState) => {
      updateState(previousState => ({
        ...previousState,
        columnFilters: newFilterState,
      }))
    },
    [updateState],
  )

  return {
    state: tableState,
    setSorting: handleSortingChange,
    setColumnFilters: handleFiltersChange,
  }
}
